import styled from 'styled-components';

export const HeaderContainer = styled.div<{ $denseFormat?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${({ theme, $denseFormat }) =>
    $denseFormat
      ? `0 ${theme.spacing(1.5)} 0 ${theme.spacing(3.5)}`
      : `${theme.spacing(2.5)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(3.5)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  flex: 1;
  min-width: 0;
`;

export const IllustrationContainer = styled.span<{
  $color: string | null | undefined;
}>`
  color: ${({ theme, $color }) => $color ?? theme.palette.grey[600]};
  font-size: 2rem;
  line-height: 62.5%;
  flex-shrink: 0;
`;

export const IconContainer = styled.span`
  display: block;
  border-radius: ${({ theme }) => theme.spacing(1.5)};
  overflow: hidden;
  line-height: 62.5%;
`;
